export default __webpack_public_path__ + "static/media/stepLines.3186a7f9.svg";